import { encodePaginatableQuery, encodeSortableQuery, PaginatableQuery, Query, SortableQuery } from '@/services/api';
import * as q from '@/services/api/request/query';

export interface SensorQuery extends PaginatableQuery, SortableQuery {
  search: string;
  entityItem: Array<number>;
}

export const encodeSensorQuery = (query: SensorQuery): Query => ({
  ...encodePaginatableQuery(query),
  search: q.string(query.search),
  ...encodeSortableQuery(query),
  entityItem: q.numbers(query.entityItem),
});
